module.exports = __webpack_public_path__ + "img/345.c9354396.jpg";